@if (!isMobileScreen) {
<table mat-table [dataSource]="dataSource()" class="mat-elevation-z8">
  @for (column of displayedColumns(); track $index) {
  <ng-container [matColumnDef]="column">
    <th mat-header-cell *matHeaderCellDef>
      {{ column.replace('_', ' ') | titlecase }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
  </ng-container>

  } >

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
} @else {
<div class="card-view">
  @for (element of dataSource(); track $index) {
  <div class="card">
    <div class="card-content row">
      @for (column of displayedColumns(); track $index) {
      <div class="col-6">
        <strong class="d-block">{{
          column.replace('_', ' ') | titlecase
        }}</strong>
        <span>{{ element[column] }}</span>
      </div>
      }
    </div>
  </div>
  }
</div>
}
